import React from 'react';
import type PolarisIdeasPageType from '@atlassian/jira-spa-apps-polaris-ideas/src/index-old.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { Redirect } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyIdeasPage = lazyForPaint<typeof PolarisIdeasPageType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-polaris-ideas", jiraSpaEntry: "async-polaris-ideas" */ '@atlassian/jira-spa-apps-polaris-ideas/src/index-old.tsx'
			),
		),
	{ ssr: false },
);

const useJpdLicensed = () => {
	const context = useTenantContext();
	return context.licensedProducts['jira-product-discovery'];
};

export const RedirectingIdeasPage = () => {
	const jpdLicensed = useJpdLicensed();
	if (!jpdLicensed) {
		return <Redirect to="/jira/polaris/unlicensed" />;
	}
	return <LazyPage Page={LazyIdeasPage} pageId="async-polaris-ideas" shouldShowSpinner={false} />;
};

export default RedirectingIdeasPage;
